import { type CSSProperties, type FC } from "react";
import * as echarts from "echarts/core";
import {
  BarChart,
  FunnelChart,
  LineChart,
  MapChart,
  PieChart,
  ScatterChart,
} from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TooltipComponent,
  VisualMapComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import type { EChartsOption } from "echarts";
import useEChart from "@/hooks/useEChart";
import styles from "@/pages/CampaignOverviewPage/components/EChart.module.css";

// Registering only the pieces this page actually renders keeps this a
// tree-shaken import instead of pulling in all of echarts. MarkLine draws the
// Performance guide lines and the bubble chart's blended-CTR reference line.
echarts.use([
  BarChart,
  FunnelChart,
  LineChart,
  MapChart,
  PieChart,
  ScatterChart,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TooltipComponent,
  VisualMapComponent,
  CanvasRenderer,
]);

interface EChartProps {
  option: EChartsOption;
  // style allows callers to override the default 22rem height for charts
  // whose row count is data-driven (e.g. horizontal bars with variable items).
  style?: CSSProperties;
}

const EChart: FC<EChartProps> = ({ option, style }) => {
  const containerRef = useEChart(option);
  return <div ref={containerRef} className={styles.chart} style={style} />;
};

export default EChart;
